import { queries } from "../../shared/queries";
import { useQuery } from "./useQuery";

// The count behind the Monitoring Requests tab badge and the Monitoring nav
// badge: connector share requests that need the viewer's review, excluding
// their own outgoing ones. Uses a relation-free query because the nav badge is
// always mounted.
export function usePendingRequestCount(): number {
  const [grantRequests] = useQuery(queries.reviewableGrantRequests());
  return grantRequests.length;
}
